import { CommandParser } from '@redis/client/dist/lib/client/parser';
import { RedisArgument, SimpleStringReply, Command } from '@redis/client/dist/lib/RESP/types';
import { RediSearchSchema, parseSchema } from './CREATE';

export default {
  parseCommand(parser: CommandParser, index: RedisArgument, schema: RediSearchSchema) {
    parser.push('FT.ALTER', index, 'SCHEMA', 'ADD');
    parseSchema(parser, schema);
  },
  transformReply: undefined as unknown as () => SimpleStringReply<'OK'>
} as const satisfies Command;
